"use strict";

jQuery( function ($) {
    if ($(document).width() < 1200) {
        //Toggle function for sub-menus (mainly intended to toggle the shopcategories in the main menu)
        $(`.shop-category-menu .shop-category-menu-controls-container, 
           .shop-category-menu .nav-main > .nav-main-item,
           .shop-category-menu .nav-level-2 > .nav-level-2-item`).on('click', function(e) {
            e.stopPropagation();

            if((!$(this).hasClass('menu-item-has-children') && !$(this).is('.shop-category-menu .shop-category-menu-controls-container'))) {
                return
            };

            $('body').addClass('nav-is-open');

            e.preventDefault();
            // Toggle the submenu
            $(this).addClass('is-open');

            if ($('.shop-category-menu-controls-container').hasClass('is-open')){
                $('.header-container').addClass('shop-cat-nav-open');
            } else {
                $('.header-container').removeClass('shop-cat-nav-open');
            }

            if($(this).is('.shop-category-menu .nav-main > .nav-main-item.menu-item-has-children')) {
                $('.shop-categories-nav-button-container-back-to').addClass('active-back-to');
            }
        });

        $('.shop-categories-nav-button-container-close, .shop-category-menu-container .desktop-nav-overlay').on('click', function(e) {
            $('.shop-category-menu-controls-container').removeClass('is-open');
            $('.header-container').removeClass('shop-cat-nav-open');
            $('body').removeClass('nav-is-open');
        });

        // back-to-previous button
        $('.shop-categories-nav-button-container-back-to').on('click', function(e) {
            if($('.nav-level-2 > .nav-level-2-item.menu-item-has-children').hasClass('is-open')) {
                $('.nav-level-2 > .nav-level-2-item.menu-item-has-children').removeClass('is-open');
            }else if ($('.nav-main > .nav-main-item.menu-item-has-children').hasClass('is-open')) {
                $('.nav-main > .nav-main-item.menu-item-has-children').removeClass('is-open');
                $('.shop-categories-nav-button-container-back-to').removeClass('active-back-to');
            }
        });
    }
});